import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { LineReveal, Eyebrow } from "./Motion";

export const PageHero = ({ eyebrow, lines, intro, image, testId = "page-hero" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section className="relative pt-36 md:pt-44" data-testid={testId}>
      <div className="grid-lines pointer-events-none absolute inset-0" aria-hidden />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-12">
        <Eyebrow>{eyebrow}</Eyebrow>
        <LineReveal
          lines={lines}
          delay={0.1}
          testId={`${testId}-title`}
          className="font-display mt-8 max-w-5xl text-4xl font-extrabold leading-[1.04] tracking-[-0.03em] text-[#0D9488] sm:text-5xl lg:text-7xl"
        />
        {intro && (
          <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.6 }} className="mt-10 max-w-2xl text-base leading-relaxed text-[#2D6A64] md:text-lg">
            {intro}
          </motion.div>
        )}
      </div>
      {image && (
        <div ref={ref} className="relative mx-auto mt-16 max-w-[1400px] px-6 lg:mt-24 lg:px-12">
          <motion.div
            initial={{ clipPath: "inset(0 0 100% 0)" }}
            animate={{ clipPath: "inset(0 0 0% 0)" }}
            transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
            className="clip-corner relative aspect-[16/10] overflow-hidden bg-[#074E48] md:aspect-[21/9]"
          >
            <motion.img src={image} alt="" style={{ y, scale: 1.2 }} className="h-full w-full object-cover" />
          </motion.div>
        </div>
      )}
    </section>
  );
};
